/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import React from 'react'
import "../../App.css";
import './ArtistsSection.css';
import CKAN from "../../imgs/artists/c_kan_logo.png";
import DONAERO from "../../imgs/artists/don_aero_logo.png"
import MELODICO from "../../imgs/artists/melodico_logo.png"
import SWAT from "../../imgs/artists/swat_logo.png"
import DUBG from "../../imgs/artists/dub-g_logo.png"
import Oscar from "../../imgs/artists/oscar_c_logo.png"


const artists = [
  {
    name: 'CKAN',
    logo: CKAN,
    instagram: 'https://www.instagram.com/ckan98/',
    facebook: 'https://www.facebook.com/CKanMEX',
    youtube: 'https://www.youtube.com/channel/UCkD89TEFWsTZluY6tk84yqg',
    apple: 'https://music.apple.com/us/artist/c-kan/305830705',
    spotify: 'https://open.spotify.com/artist/1QhaqxeqF9sipS2gwbEKpu?si=qt0Wjxi4SiuG0poydNjOxA&nd=1',
    link: "https://ckan.mx"
  },
  {
    name: 'DONAERO',
    logo: DONAERO,
    instagram: 'https://www.instagram.com/donaerohiphop/',
    facebook: 'https://www.facebook.com/donaerohiphop',
    youtube: 'https://www.youtube.com/channel/UCaEZ1OAjebcZOnVcNhBZrZQ',
    apple: 'https://music.apple.com/us/artist/don-aero/431764834',
    spotify: 'https://open.spotify.com/artist/2EkFEL5IvD2W8hpwbjS9yv',
    link: "/DonAero"
  },
  {
    name: 'MELODICO',
    logo: MELODICO,
    instagram: 'https://www.instagram.com/melodico/',
    facebook: 'https://www.facebook.com/MelodicoRnb',
    youtube: 'https://www.youtube.com/user/MelodicoVEVO',
    apple: 'https://music.apple.com/us/artist/melodico/464785275',
    spotify: 'https://open.spotify.com/artist/0S6XZyWww6AyEUfk62wRJg',
    link: "/Melodico"
  },
  {
    name: 'SWAT',
    logo: SWAT,
    instagram: 'https://www.instagram.com/swat_c_mobztas/',
    facebook: 'https://www.facebook.com/SWATCMOB/?ref=br_rs',
    youtube: 'https://www.youtube.com/@swatcmobztas8014',
    apple: 'https://music.apple.com/us/artist/swat/145013042',
    spotify: 'https://open.spotify.com/album/4vennctX8Qc3EHk0d3qaDH',
    link: "/Swat"
  },
  {
    name: 'DUB G',
    logo: DUBG,
    instagram: 'https://www.instagram.com/dubskillaz/',
    facebook: '',
    youtube: 'https://www.youtube.com/channel/UCX_Ymdf_bsVEoP6BpZOGV0Q',
    apple: 'https://music.apple.com/us/artist/dub-g/1516125207',
    spotify: 'https://open.spotify.com/artist/5SVHvnw9UIDoLNC745Lt8V?si=S_4gJau8RBWW_q3d8jqk6w',
    link: "/DubG"
  },
  {
    name: 'Oscar Calderon',
    logo: Oscar,
    instagram: 'https://www.instagram.com/oscarcalderonmx/',
    facebook: 'https://www.facebook.com/oscarcalderonmx',
    youtube: 'https://www.youtube.com/channel/UCPblXiMJbfHIWLnTPj18ppg',
    apple: '',
    spotify: '',
    link: "/OscarC"
  },
];

function ArtistsSection() {
  return (
    <div className='artists_wrap'> 
      <section loading="eager" className="artiststop__section">
        <header>
          <h1>ARTISTAS</h1>
        </header>
      </section>
      <div className="artists-container">
        {artists.map((artist, index) => (
            <a href={artist.link} key={index} rel="noopener noreferrer">
              <div className={`artists-card card${index}`}>
                <div className="border">
                  <img className='artists-logo' alt={artist.name} loading="lazy" src={artist.logo} preload="auto" />
          </div>
        </div>
      </a>
    ))}
  </div>
</div>
);

}

export default ArtistsSection

 